/**
 * @generated SignedSource<<fa40948ad532626becbeeba9ab372fc7>>
 * @relayHash aa2944c974117036489e2242c095af4d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7244f1cd300190cdd505477b02ea1402df2661952e2553bff653852568dcff25

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type SavedViewUpdatesAggRootQuery$variables = {
  containerId: string;
  directoryId: string;
  shouldFetchGoalsData: boolean;
  shouldFetchProjectsData: boolean;
  viewUuid: string;
};
export type SavedViewUpdatesAggRootQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SavedViewUpdatesMainColumnAgg">;
};
export type SavedViewUpdatesAggRootQuery = {
  response: SavedViewUpdatesAggRootQuery$data;
  variables: SavedViewUpdatesAggRootQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "containerId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "directoryId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldFetchGoalsData"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldFetchProjectsData"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewUuid"
},
v5 = {
  "kind": "Variable",
  "name": "containerId",
  "variableName": "containerId"
},
v6 = {
  "kind": "Variable",
  "name": "directoryId",
  "variableName": "directoryId"
},
v7 = {
  "kind": "Variable",
  "name": "viewUuid",
  "variableName": "viewUuid"
},
v8 = [
  (v5/*: any*/),
  (v6/*: any*/)
],
v9 = {
  "kind": "ScalarField",
  "name": "name"
},
v10 = {
  "kind": "ScalarField",
  "name": "id"
},
v11 = [
  (v9/*: any*/),
  {
    "kind": "ScalarField",
    "name": "entityType"
  },
  (v10/*: any*/),
  {
    "alias": "uuid",
    "kind": "ScalarField",
    "name": "id"
  },
  {
    "kind": "ScalarField",
    "name": "isFavourite"
  }
],
v12 = {
  "kind": "Literal",
  "name": "first",
  "value": 10
},
v13 = [
  (v5/*: any*/),
  (v12/*: any*/),
  (v7/*: any*/)
],
v14 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v15 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v16 = {
  "kind": "ScalarField",
  "name": "canCommentOnUpdates"
},
v17 = {
  "kind": "ScalarField",
  "name": "canEditUpdates"
},
v18 = {
  "kind": "ScalarField",
  "name": "key"
},
v19 = {
  "kind": "ScalarField",
  "name": "isArchived"
},
v20 = {
  "kind": "ScalarField",
  "name": "summary"
},
v21 = {
  "kind": "ScalarField",
  "name": "description"
},
v22 = [
  (v10/*: any*/),
  (v20/*: any*/),
  {
    "concreteType": "TownsquareUpdateNoteConnection",
    "kind": "LinkedField",
    "name": "updateNotes",
    "plural": false,
    "selections": [
      {
        "concreteType": "TownsquareUpdateNoteEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "concreteType": "TownsquareUpdateNote",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v20/*: any*/),
              (v21/*: any*/),
              (v10/*: any*/)
            ]
          }
        ]
      }
    ]
  }
],
v23 = {
  "kind": "ScalarField",
  "name": "url"
},
v24 = {
  "kind": "ScalarField",
  "name": "canCreateUpdates"
},
v25 = {
  "kind": "ScalarField",
  "name": "ari"
},
v26 = {
  "kind": "ScalarField",
  "name": "missedUpdate"
},
v27 = {
  "kind": "ScalarField",
  "name": "updateType"
},
v28 = {
  "kind": "ScalarField",
  "name": "picture"
},
v29 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v30 = {
  "kind": "ScalarField",
  "name": "label"
},
v31 = {
  "kind": "ScalarField",
  "name": "start"
},
v32 = {
  "concreteType": "TownsquareTargetDateRange",
  "kind": "LinkedField",
  "name": "dateRange",
  "plural": false,
  "selections": [
    (v31/*: any*/),
    {
      "kind": "ScalarField",
      "name": "end"
    }
  ]
},
v33 = [
  (v30/*: any*/),
  (v32/*: any*/)
],
v34 = {
  "concreteType": "TownsquareTargetDate",
  "kind": "LinkedField",
  "name": "newDueDate",
  "plural": false,
  "selections": (v33/*: any*/)
},
v35 = [
  {
    "alias": "projectValue",
    "kind": "ScalarField",
    "name": "value"
  }
],
v36 = {
  "kind": "LinkedField",
  "name": "lastEditedBy",
  "plural": false,
  "selections": [
    (v14/*: any*/),
    (v29/*: any*/),
    (v9/*: any*/),
    (v10/*: any*/)
  ]
},
v37 = {
  "kind": "ScalarField",
  "name": "creationDate"
},
v38 = {
  "kind": "ScalarField",
  "name": "editDate"
},
v39 = [
  (v10/*: any*/)
],
v40 = [
  {
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v14/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v10/*: any*/),
          (v9/*: any*/),
          (v29/*: any*/),
          (v28/*: any*/)
        ],
        "type": "AtlassianAccountUser"
      },
      {
        "kind": "InlineFragment",
        "selections": (v39/*: any*/),
        "type": "AppUser"
      },
      {
        "kind": "InlineFragment",
        "selections": (v39/*: any*/),
        "type": "CustomerUser"
      }
    ]
  },
  (v10/*: any*/)
],
v41 = {
  "concreteType": "TownsquareTargetDate",
  "kind": "LinkedField",
  "name": "oldDueDate",
  "plural": false,
  "selections": (v33/*: any*/)
},
v42 = {
  "kind": "ScalarField",
  "name": "newTargetDate"
},
v43 = {
  "kind": "ScalarField",
  "name": "newTargetDateConfidence"
},
v44 = {
  "kind": "ScalarField",
  "name": "archived"
},
v45 = {
  "concreteType": "TownsquareUpdateNoteConnection",
  "kind": "LinkedField",
  "name": "updateNotes",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareUpdateNoteEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareUpdateNote",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v10/*: any*/),
            (v20/*: any*/),
            (v21/*: any*/),
            (v44/*: any*/)
          ]
        }
      ]
    }
  ]
},
v46 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isTownsquareHighlight"
},
v47 = [
  (v14/*: any*/),
  (v28/*: any*/),
  (v9/*: any*/),
  (v29/*: any*/),
  (v10/*: any*/)
],
v48 = {
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": (v47/*: any*/)
},
v49 = {
  "kind": "LinkedField",
  "name": "lastEditedBy",
  "plural": false,
  "selections": (v47/*: any*/)
},
v50 = {
  "kind": "ScalarField",
  "name": "lastEditedDate"
},
v51 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v52 = {
  "concreteType": "TownsquareHighlightConnection",
  "kind": "LinkedField",
  "name": "highlights",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareHighlightEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v20/*: any*/),
            (v21/*: any*/),
            (v14/*: any*/),
            (v10/*: any*/),
            (v46/*: any*/),
            (v48/*: any*/),
            (v49/*: any*/),
            (v37/*: any*/),
            (v50/*: any*/)
          ]
        }
      ]
    },
    (v51/*: any*/)
  ]
},
v53 = {
  "concreteType": "TownsquareCommentConnection",
  "kind": "LinkedField",
  "name": "comments",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareCommentEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareComment",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v10/*: any*/),
            {
              "kind": "LinkedField",
              "name": "creator",
              "plural": false,
              "selections": [
                (v14/*: any*/),
                (v9/*: any*/),
                (v10/*: any*/),
                (v29/*: any*/),
                (v28/*: any*/)
              ]
            },
            {
              "kind": "ScalarField",
              "name": "commentText"
            },
            (v38/*: any*/),
            (v37/*: any*/)
          ]
        }
      ]
    },
    (v51/*: any*/)
  ]
},
v54 = {
  "kind": "ScalarField",
  "name": "value"
},
v55 = {
  "kind": "ScalarField",
  "name": "scoringMode"
},
v56 = [
  (v54/*: any*/)
],
v57 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "messageId"
    },
    {
      "kind": "ScalarField",
      "name": "defaultValue"
    }
  ],
  "type": "TownsquareLocalizationField"
},
v58 = {
  "kind": "LinkedField",
  "name": "name",
  "plural": false,
  "selections": [
    (v14/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v56/*: any*/),
      "type": "TownsquareGoalTypeCustomName"
    },
    (v57/*: any*/)
  ]
},
v59 = {
  "kind": "LinkedField",
  "name": "namePlural",
  "plural": false,
  "selections": [
    (v14/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v56/*: any*/),
      "type": "TownsquareGoalTypeCustomNamePlural"
    },
    (v57/*: any*/)
  ]
},
v60 = {
  "kind": "ScalarField",
  "name": "type"
},
v61 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  }
],
v62 = {
  "kind": "ScalarField",
  "name": "percentage"
},
v63 = {
  "concreteType": "TownsquareGoalProgress",
  "kind": "LinkedField",
  "name": "progress",
  "plural": false,
  "selections": [
    (v62/*: any*/),
    (v60/*: any*/)
  ]
},
v64 = {
  "kind": "ScalarField",
  "name": "subType"
},
v65 = {
  "kind": "ScalarField",
  "name": "source"
},
v66 = {
  "kind": "ScalarField",
  "name": "time"
},
v67 = {
  "concreteType": "TownsquareMetricValue",
  "kind": "LinkedField",
  "name": "latestValue",
  "plural": false,
  "selections": [
    (v66/*: any*/),
    (v10/*: any*/)
  ]
},
v68 = {
  "concreteType": "TownsquareMetricTargetConnection",
  "kind": "LinkedField",
  "name": "metricTargets",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareMetricTargetEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareMetricTarget",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v10/*: any*/),
            {
              "concreteType": "TownsquareMetric",
              "kind": "LinkedField",
              "name": "metric",
              "plural": false,
              "selections": [
                (v10/*: any*/),
                (v9/*: any*/),
                (v60/*: any*/),
                (v64/*: any*/),
                (v44/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "externalEntityId"
                },
                (v65/*: any*/),
                (v67/*: any*/)
              ]
            },
            {
              "concreteType": "TownsquareMetricValue",
              "kind": "LinkedField",
              "name": "snapshotValue",
              "plural": false,
              "selections": [
                (v54/*: any*/),
                (v10/*: any*/)
              ]
            },
            {
              "kind": "ScalarField",
              "name": "startValue"
            },
            {
              "kind": "ScalarField",
              "name": "targetValue"
            }
          ]
        }
      ]
    }
  ]
},
v69 = {
  "concreteType": "TownsquareTargetDate",
  "kind": "LinkedField",
  "name": "targetDate",
  "plural": false,
  "selections": [
    (v32/*: any*/)
  ]
},
v70 = [
  (v14/*: any*/),
  (v29/*: any*/),
  (v9/*: any*/),
  (v28/*: any*/),
  (v10/*: any*/)
],
v71 = {
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": (v70/*: any*/)
},
v72 = {
  "kind": "ScalarField",
  "name": "score"
},
v73 = {
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": (v70/*: any*/)
},
v74 = [
  (v37/*: any*/),
  {
    "concreteType": "TownsquareGoalState",
    "kind": "LinkedField",
    "name": "newState",
    "plural": false,
    "selections": [
      (v54/*: any*/),
      (v72/*: any*/),
      (v30/*: any*/)
    ]
  },
  (v20/*: any*/),
  (v73/*: any*/),
  (v45/*: any*/),
  {
    "concreteType": "TownsquareHighlightConnection",
    "kind": "LinkedField",
    "name": "highlights",
    "plural": false,
    "selections": [
      {
        "concreteType": "TownsquareHighlightEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v14/*: any*/),
              (v10/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v46/*: any*/),
              (v48/*: any*/),
              (v49/*: any*/),
              (v37/*: any*/),
              (v50/*: any*/)
            ]
          }
        ]
      },
      (v51/*: any*/)
    ]
  },
  (v10/*: any*/)
],
v75 = {
  "concreteType": "TownsquareGoalUpdate",
  "kind": "LinkedField",
  "name": "latestUserUpdate",
  "plural": false,
  "selections": (v74/*: any*/)
},
v76 = {
  "concreteType": "TownsquareGoalTypeIcon",
  "kind": "LinkedField",
  "name": "icon",
  "plural": false,
  "selections": [
    (v18/*: any*/)
  ]
},
v77 = [
  (v54/*: any*/),
  (v72/*: any*/)
],
v78 = {
  "concreteType": "TownsquareStatus",
  "kind": "LinkedField",
  "name": "status",
  "plural": false,
  "selections": (v77/*: any*/)
},
v79 = [
  (v12/*: any*/)
],
v80 = [
  {
    "concreteType": "TownsquareGoalUpdateEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "TownsquareGoalUpdate",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v26/*: any*/),
          (v27/*: any*/),
          (v20/*: any*/),
          (v38/*: any*/),
          (v37/*: any*/),
          (v10/*: any*/)
        ]
      }
    ]
  }
],
v81 = [
  (v54/*: any*/),
  (v66/*: any*/),
  (v10/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "SavedViewUpdatesAggRootQuery",
    "selections": [
      {
        "args": [
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "kind": "Variable",
            "name": "shouldFetchGoalsData",
            "variableName": "shouldFetchGoalsData"
          },
          {
            "kind": "Variable",
            "name": "shouldFetchProjectsData",
            "variableName": "shouldFetchProjectsData"
          },
          (v7/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "SavedViewUpdatesMainColumnAgg"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "SavedViewUpdatesAggRootQuery",
    "selections": [
      {
        "condition": "shouldFetchGoalsData",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v8/*: any*/),
            "concreteType": "TownsquareDirectoryView",
            "kind": "LinkedField",
            "name": "goals_directoryViewById",
            "plural": false,
            "selections": (v11/*: any*/)
          }
        ]
      },
      {
        "condition": "shouldFetchProjectsData",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v8/*: any*/),
            "concreteType": "TownsquareDirectoryView",
            "kind": "LinkedField",
            "name": "projects_directoryViewById",
            "plural": false,
            "selections": (v11/*: any*/)
          },
          {
            "args": [
              (v5/*: any*/),
              {
                "kind": "Variable",
                "name": "directoryViewId",
                "variableName": "directoryId"
              }
            ],
            "concreteType": "TownsquareSearchExplanation",
            "kind": "LinkedField",
            "name": "projects_explainSearch",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "logSafeQuery"
              }
            ]
          }
        ]
      },
      {
        "args": (v13/*: any*/),
        "concreteType": "TownsquareUpdateConnection",
        "kind": "LinkedField",
        "name": "statusUpdates_forSavedView",
        "plural": false,
        "selections": [
          {
            "concreteType": "TownsquareUpdateEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v14/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v10/*: any*/),
                      {
                        "concreteType": "TownsquareProject",
                        "kind": "LinkedField",
                        "name": "project",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "watching"
                          },
                          (v15/*: any*/),
                          {
                            "concreteType": "TownsquareProjectCapabilities",
                            "kind": "LinkedField",
                            "name": "capabilities",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "canWatchProject"
                              },
                              (v16/*: any*/),
                              (v17/*: any*/)
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "isPrivate"
                          },
                          {
                            "concreteType": "TownsquareIconURIs",
                            "kind": "LinkedField",
                            "name": "iconUrl",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareThemeURIs",
                                "kind": "LinkedField",
                                "name": "square",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "light"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "dark"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "transparent"
                                  }
                                ]
                              }
                            ]
                          },
                          (v18/*: any*/),
                          (v9/*: any*/),
                          (v19/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "startDate"
                          },
                          {
                            "concreteType": "TownsquareProjectUpdate",
                            "kind": "LinkedField",
                            "name": "latestUserUpdate",
                            "plural": false,
                            "selections": (v22/*: any*/)
                          },
                          (v23/*: any*/),
                          {
                            "concreteType": "TownsquareProjectCapabilities",
                            "kind": "LinkedField",
                            "name": "capabilities",
                            "plural": false,
                            "selections": [
                              (v24/*: any*/)
                            ]
                          }
                        ]
                      },
                      (v25/*: any*/),
                      (v26/*: any*/),
                      (v27/*: any*/),
                      (v20/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "creator",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/),
                          (v9/*: any*/),
                          (v28/*: any*/),
                          (v10/*: any*/),
                          (v29/*: any*/)
                        ]
                      },
                      (v34/*: any*/),
                      {
                        "concreteType": "TownsquareProjectState",
                        "kind": "LinkedField",
                        "name": "newState",
                        "plural": false,
                        "selections": (v35/*: any*/)
                      },
                      (v36/*: any*/),
                      (v37/*: any*/),
                      (v38/*: any*/),
                      (v23/*: any*/),
                      {
                        "concreteType": "GraphStoreSimplifiedUserViewedProjectUpdateInverseConnection",
                        "kind": "LinkedField",
                        "name": "viewers",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "GraphStoreSimplifiedUserViewedProjectUpdateInverseEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": (v40/*: any*/)
                          }
                        ]
                      },
                      {
                        "concreteType": "TownsquareProjectState",
                        "kind": "LinkedField",
                        "name": "oldState",
                        "plural": false,
                        "selections": (v35/*: any*/)
                      },
                      (v41/*: any*/),
                      (v42/*: any*/),
                      (v43/*: any*/),
                      (v45/*: any*/),
                      (v52/*: any*/),
                      (v53/*: any*/)
                    ],
                    "type": "TownsquareProjectUpdate"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v10/*: any*/),
                      {
                        "concreteType": "TownsquareGoal",
                        "kind": "LinkedField",
                        "name": "goal",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "isWatching"
                          },
                          (v15/*: any*/),
                          {
                            "concreteType": "TownsquareGoalCapabilities",
                            "kind": "LinkedField",
                            "name": "capabilities",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "canWatchGoal"
                              },
                              (v24/*: any*/),
                              (v17/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "canDeleteUpdates"
                              },
                              (v16/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "TownsquareGoal",
                            "kind": "LinkedField",
                            "name": "parentGoal",
                            "plural": false,
                            "selections": (v39/*: any*/)
                          },
                          (v18/*: any*/),
                          (v9/*: any*/),
                          {
                            "concreteType": "TownsquareGoalIcon",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                              (v18/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "appearance"
                              }
                            ]
                          },
                          {
                            "concreteType": "TownsquareMetricTargetConnection",
                            "kind": "LinkedField",
                            "name": "metricTargets",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareMetricTargetEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareMetricTarget",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareMetric",
                                        "kind": "LinkedField",
                                        "name": "metric",
                                        "plural": false,
                                        "selections": [
                                          (v10/*: any*/),
                                          (v44/*: any*/)
                                        ]
                                      },
                                      {
                                        "concreteType": "TownsquareMetricTargetPeriodConnection",
                                        "kind": "LinkedField",
                                        "name": "metricTargetPeriods",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareMetricTargetPeriodEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "TownsquareMetricTargetPeriod",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "TownsquareTargetDate",
                                                    "kind": "LinkedField",
                                                    "name": "date",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "TownsquareTargetDateRange",
                                                        "kind": "LinkedField",
                                                        "name": "dateRange",
                                                        "plural": false,
                                                        "selections": [
                                                          (v31/*: any*/)
                                                        ]
                                                      }
                                                    ]
                                                  },
                                                  (v54/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      (v10/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          (v55/*: any*/),
                          (v44/*: any*/),
                          {
                            "concreteType": "TownsquareGoalType",
                            "kind": "LinkedField",
                            "name": "goalType",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalType",
                                "kind": "LinkedField",
                                "name": "successMeasure",
                                "plural": false,
                                "selections": [
                                  (v58/*: any*/),
                                  (v59/*: any*/),
                                  (v10/*: any*/)
                                ]
                              },
                              (v10/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "TownsquareGoalProgress",
                            "kind": "LinkedField",
                            "name": "progress",
                            "plural": false,
                            "selections": [
                              (v60/*: any*/)
                            ]
                          },
                          {
                            "args": (v61/*: any*/),
                            "concreteType": "TownsquareGoalConnection",
                            "kind": "LinkedField",
                            "name": "successMeasures",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoal",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v10/*: any*/),
                                      (v9/*: any*/),
                                      (v44/*: any*/),
                                      (v63/*: any*/),
                                      (v68/*: any*/),
                                      (v23/*: any*/),
                                      (v55/*: any*/),
                                      (v69/*: any*/),
                                      (v71/*: any*/),
                                      (v75/*: any*/),
                                      (v15/*: any*/),
                                      (v19/*: any*/),
                                      {
                                        "concreteType": "TownsquareGoalType",
                                        "kind": "LinkedField",
                                        "name": "goalType",
                                        "plural": false,
                                        "selections": [
                                          (v58/*: any*/),
                                          (v59/*: any*/),
                                          (v76/*: any*/),
                                          (v10/*: any*/)
                                        ]
                                      },
                                      (v78/*: any*/),
                                      {
                                        "args": (v79/*: any*/),
                                        "concreteType": "TownsquareGoalUpdateConnection",
                                        "kind": "LinkedField",
                                        "name": "updates",
                                        "plural": false,
                                        "selections": (v80/*: any*/),
                                        "storageKey": "updates(first:10)"
                                      }
                                    ]
                                  },
                                  (v14/*: any*/)
                                ]
                              }
                            ],
                            "storageKey": "successMeasures(first:50)"
                          },
                          {
                            "concreteType": "TownsquareGoalConnection",
                            "kind": "LinkedField",
                            "name": "subGoals",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoal",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v10/*: any*/),
                                      (v9/*: any*/),
                                      (v44/*: any*/),
                                      (v63/*: any*/),
                                      {
                                        "concreteType": "TownsquareGoalType",
                                        "kind": "LinkedField",
                                        "name": "goalType",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "kind"
                                          },
                                          (v10/*: any*/),
                                          (v76/*: any*/)
                                        ]
                                      },
                                      (v68/*: any*/),
                                      (v23/*: any*/),
                                      (v55/*: any*/),
                                      (v69/*: any*/),
                                      (v71/*: any*/),
                                      (v75/*: any*/),
                                      (v19/*: any*/),
                                      (v78/*: any*/),
                                      {
                                        "args": [
                                          {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 30
                                          }
                                        ],
                                        "concreteType": "TownsquareGoalUpdateConnection",
                                        "kind": "LinkedField",
                                        "name": "updates",
                                        "plural": false,
                                        "selections": (v80/*: any*/),
                                        "storageKey": "updates(first:30)"
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "args": (v79/*: any*/),
                            "concreteType": "TownsquareGoalUpdateConnection",
                            "kind": "LinkedField",
                            "name": "updates",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalUpdateEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoalUpdate",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": (v22/*: any*/)
                                  }
                                ]
                              }
                            ],
                            "storageKey": "updates(first:10)"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "canPostUpdate"
                          },
                          (v19/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "canEditUpdate"
                          }
                        ]
                      },
                      (v26/*: any*/),
                      (v27/*: any*/),
                      (v20/*: any*/),
                      {
                        "concreteType": "TownsquareGoalState",
                        "kind": "LinkedField",
                        "name": "newState",
                        "plural": false,
                        "selections": (v77/*: any*/)
                      },
                      (v42/*: any*/),
                      (v43/*: any*/),
                      (v45/*: any*/),
                      (v52/*: any*/),
                      (v37/*: any*/),
                      {
                        "concreteType": "TownsquareGoalMetricUpdateConnection",
                        "kind": "LinkedField",
                        "name": "metricUpdate",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareGoalMetricUpdateEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalMetricUpdate",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareMetric",
                                    "kind": "LinkedField",
                                    "name": "metric",
                                    "plural": false,
                                    "selections": [
                                      (v10/*: any*/),
                                      (v9/*: any*/),
                                      (v60/*: any*/),
                                      (v64/*: any*/),
                                      (v44/*: any*/),
                                      (v65/*: any*/),
                                      (v67/*: any*/),
                                      {
                                        "args": [
                                          {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 100
                                          },
                                          {
                                            "kind": "Literal",
                                            "name": "sort",
                                            "value": [
                                              "TIME_DESC"
                                            ]
                                          }
                                        ],
                                        "concreteType": "TownsquareMetricValueConnection",
                                        "kind": "LinkedField",
                                        "name": "values",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareMetricValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "TownsquareMetricValue",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": (v81/*: any*/)
                                              }
                                            ]
                                          }
                                        ],
                                        "storageKey": "values(first:100,sort:[\"TIME_DESC\"])"
                                      }
                                    ]
                                  },
                                  {
                                    "concreteType": "TownsquareMetricValue",
                                    "kind": "LinkedField",
                                    "name": "newValue",
                                    "plural": false,
                                    "selections": (v81/*: any*/)
                                  },
                                  {
                                    "concreteType": "TownsquareMetricValue",
                                    "kind": "LinkedField",
                                    "name": "oldValue",
                                    "plural": false,
                                    "selections": [
                                      (v66/*: any*/),
                                      (v10/*: any*/),
                                      (v54/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "newStartValue"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "newTargetValue"
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v73/*: any*/),
                      (v34/*: any*/),
                      {
                        "args": (v61/*: any*/),
                        "concreteType": "TownsquareGoalBundledUpdateConnection",
                        "kind": "LinkedField",
                        "name": "bundledUpdates",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareGoalBundledUpdateEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoal",
                                "kind": "LinkedField",
                                "name": "successMeasure",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoalProgress",
                                    "kind": "LinkedField",
                                    "name": "progress",
                                    "plural": false,
                                    "selections": [
                                      (v62/*: any*/)
                                    ]
                                  },
                                  (v10/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "TownsquareGoalUpdate",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": (v74/*: any*/)
                              },
                              {
                                "kind": "ScalarField",
                                "name": "nodeMissingReason"
                              },
                              {
                                "concreteType": "TownsquareGoal",
                                "kind": "LinkedField",
                                "name": "goal",
                                "plural": false,
                                "selections": [
                                  (v10/*: any*/),
                                  (v9/*: any*/),
                                  {
                                    "concreteType": "TownsquareGoalProgress",
                                    "kind": "LinkedField",
                                    "name": "progress",
                                    "plural": false,
                                    "selections": [
                                      (v60/*: any*/),
                                      (v62/*: any*/)
                                    ]
                                  },
                                  (v68/*: any*/),
                                  (v23/*: any*/),
                                  (v55/*: any*/),
                                  (v69/*: any*/),
                                  (v71/*: any*/)
                                ]
                              }
                            ]
                          }
                        ],
                        "storageKey": "bundledUpdates(first:50)"
                      },
                      (v36/*: any*/),
                      (v38/*: any*/),
                      (v23/*: any*/),
                      {
                        "concreteType": "GraphStoreSimplifiedUserViewedGoalUpdateInverseConnection",
                        "kind": "LinkedField",
                        "name": "viewers",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "GraphStoreSimplifiedUserViewedGoalUpdateInverseEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": (v40/*: any*/)
                          }
                        ]
                      },
                      (v25/*: any*/),
                      (v53/*: any*/),
                      {
                        "concreteType": "TownsquareGoalState",
                        "kind": "LinkedField",
                        "name": "oldState",
                        "plural": false,
                        "selections": (v77/*: any*/)
                      },
                      (v41/*: any*/)
                    ],
                    "type": "TownsquareGoalUpdate"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v39/*: any*/),
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ]
              },
              (v14/*: any*/),
              {
                "kind": "ScalarField",
                "name": "cursor"
              }
            ]
          },
          {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "endCursor"
              },
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              }
            ]
          }
        ]
      },
      {
        "args": (v13/*: any*/),
        "filters": [
          "viewUuid",
          "containerId"
        ],
        "handle": "connection",
        "key": "SavedViewUpdatesFeedAgg_statusUpdates_forSavedView",
        "kind": "LinkedHandle",
        "name": "statusUpdates_forSavedView"
      }
    ]
  },
  "params": {
    "id": "7244f1cd300190cdd505477b02ea1402df2661952e2553bff653852568dcff25",
    "metadata": {},
    "name": "SavedViewUpdatesAggRootQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "c8d966348def1cdcce35819a1a8c3318";

export default node;
